<template>
  <v-card class="card-item pb-4 pt-5 px-5" @click="handleSelect">
    <div class="pb-6 poistenie-card-img">
      <v-row no-gutters>
        <v-col cols="7" class="pr-0px">
          <v-img :src="getImage(value)" contain height="48" width="100"></v-img>
        </v-col>
        <v-col cols="5" class="pl-0px"> </v-col>
      </v-row>
    </div>

    <div class="ponuka-info-1 pb-4 font-weight-bold" v-show="value.displayMember">
      <p>{{ value.displayMember }}</p>
      <!-- <p>{{ '' }}</p> -->
    </div>
    <div class="ponuka-info-2" style="display: flex">
      <v-col cols="6" class="pa-0" v-if="value.spoluucast">
          <div class="tr-label">Spoluúčasť</div>
          <div class="tr-content">
            {{ value.spoluucast }}
          </div>
      </v-col>
      <v-col v-if="!isOlfs" cols="6" class="pa-0" :style="value.spoluucast ? 'text-align: right' : ''">
        <div class="tr-label">Ročné poistné</div>
        <div class="tr-content">
          {{ value.poistne_rocne ? value.poistne_rocne : '' }}
        </div>
      </v-col>
    </div>
    <v-spacer></v-spacer>
    <v-divider v-if="!isOlfs || addButton" class="my-2"></v-divider>
    <div class="poistenie-card-footer">
      <v-icon v-if="!isOlfs" class="" @click.stop="openDetailDialog(value)"> $detail_zmluvy </v-icon>
      <v-btn
        class="pripoistenie-btn"
        v-show="addButton && isSelected"
        @click.stop="addButtonClicked()"
        outlined
      >
        Pripoistenie
        <v-icon> mdi-plus </v-icon>
      </v-btn>
    </div>
  </v-card>
</template>
<script>
import { poistenieMixin } from '../../mixins/poistenieMixin';

export default {
  mixins: [poistenieMixin],
};
</script>
